import React, { useEffect, useState } from "react";
import {
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import VendorNeedApprovalListSnf from "./VendorNeedTabs/Components/VendorNeedApprovalListSnf";
import PendingListSnf from "./VendorNeedTabs/Components/PendingListSnf";
import { useDispatch, useSelector } from "react-redux";
import { fetchReviewRequestResponseforApprover } from "../../../../AssesmentForm/TabsComponents/Action";
import NeedFormReviewRequest from "../NeedFormReviewRequest/NeedFormReviewRequest";

const VendorNeedApprovalHavells = ({
  selfAssesmentId,
  viewDataFromSupplier,
}) => {

  const [activeTab, setActiveTab] = useState("1");
  const dispatch = useDispatch();
  const { reviewRequestResponseData } = useSelector(
    (state) => state?.ReviewRequestResponseData
  );

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  useEffect(() => {
    getUsers(selfAssesmentId);
  }, []);

  if (activeTab === undefined) {
    return null; // Or render a loading indicator until activeTab is defined
  }
  const getUsers = async (data) => {
    try {
      await dispatch(
        fetchReviewRequestResponseforApprover({
          VendorRequirementRegistrationId: data,
        })
      );
    } catch (error) { }
  };
  return (
    <div className="hl-vendor-need-approval-wrap hl-vl-common-wrap mt-3">
      <div className="hl-approval-tabs">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "1" })}
              onClick={() => {
                toggle("1");
              }}
            >
              {viewDataFromSupplier?.IsBlockedVendor ? 'Unblocking Form Approval' : 'Supplier Form Approval'}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "2" })}
              onClick={() => {
                toggle("2");
              }}
            >
              Pending List
            </NavLink>
          </NavItem>
          {reviewRequestResponseData &&
            reviewRequestResponseData?.Data?.RequestReviews?.length > 0 && (
              <NavItem>
                <NavLink
                  id={`dashboard_Masters_Awaiting_Approval`}
                  className={classnames({ active: activeTab === "3" })}
                  onClick={() => {
                    toggle("3");
                  }}
                >
                  Review Request{" "}
                  <span>
                    {reviewRequestResponseData?.Data?.RequestReviewCount == 0 ? "" : reviewRequestResponseData?.Data?.RequestReviewCount}
                  </span>
                </NavLink>
              </NavItem>
            )}
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <VendorNeedApprovalListSnf
              selfAssesmentId={selfAssesmentId}
            />
          </TabPane>
          <TabPane tabId="2">
            <PendingListSnf selfAssesmentId={selfAssesmentId} viewDataFromSupplier={viewDataFromSupplier} />
          </TabPane>
          <TabPane tabId="3">
            <TabPane tabId="3" className="hl-vendor-need-view">
              <NeedFormReviewRequest
                reviewRequestResponseData={reviewRequestResponseData}
                viewDataFromSupplier={viewDataFromSupplier}
              />
            </TabPane>
          </TabPane>
          <TabPane tabId="4">
            <Col sm="12">
              <h4>Tab 4 Contents</h4>
              <p>Here is where you can add content for Tab 4.</p>
            </Col>
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
};

export default VendorNeedApprovalHavells;
